import { render, staticRenderFns } from "./CmsSocialIcon.vue?vue&type=template&id=a8bf4794&"
import script from "./CmsSocialIcon.vue?vue&type=script&lang=ts&"
export * from "./CmsSocialIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports